import { administrationRequests } from "api/administrationApi";
import { AutocompleteInput, ReferenceInput, required, SelectInput, TextInput } from "react-admin";
import { Grid } from "@mui/material";
import { settings } from "app";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={4}
      sx={{ ...settings.style.shadowBox, padding: ".5rem", justifyContent: "center", paddingRight: "3rem" }}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="nameBg"
          label="Име на български"
          fullWidth
          validate={required()}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="nameEn"
          label="Име на английски"
          fullWidth
          validate={required()}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="departmentId"
          reference={administrationRequests.getDepartmentsSelect()}
          label="Катедра"
        >
          <AutocompleteInput
            validate={required()}
            label="Катедра"
            optionText="fullName"
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="hospitalityId"
          reference={administrationRequests.getHospitalitiesSelect()}
          label="Болница"
        >
          <SelectInput
            label="Болница"
            optionText="nameBg"
            emptyText="—"
          />
        </ReferenceInput>
      </Grid>
    </Grid>
  );
};
export default SaveForm;
